<template>
  <qx-card-form title="线路信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="sourceAddressInfo" slot-scope="prop">
        <ChooseStartingAddress
          v-model="prop.form.sourceAddressInfo"
          :isRadio="true"
          :customerNameDisabled="true"
          :addressTypeDisabled="true"
          :disabled="!customerName"
          :otherSearchData="{
            addressType: '0',
            customerName: customerName || '',
          }"
          @change="handleStartingAddressChange"
        />
      </section>
      <span slot="test">
        <button @click="getDataTest">测试提交参数</button>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
// import {
//   cityAddressQueryPage,
// } from 'api/distribution';
import ChooseStartingAddress from 'components/choose/startingAddress';
// import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
export default {
  components: {
    ChooseStartingAddress,
    // ChooseAddressMap,
  },
  data () {
    return {
      customerName: '',
      // 用来做修改数据对比
      subLinaAreaBackUp: [],
      // 所有省市区
      addressList: [],
      // 地图选点之后保存临时数据的变量
      sourceTemp: {},
      // 目的地列表
      desTempList: [],
      // 其他非表单又需要提交的数据
      otherFormData: {
        // 所有选择的区县列表
        subLinaAreaList: [],
      },
      baseForm: {
        orgIdOptions: [],
        targetCityOptions: [],
        distributionAreaOptions: [],
        inline: true,
        form: [
          {
            label: '出发地址',
            value: 'sourceAddressInfo',
            default: {},
            slot: true,
          },
          {
            label: '导航地址',
            value: 'sourceAddressNavigation',
            type: 'input',
            disabled: true,
          },
          {
            label: '目的城市',
            value: 'targetCity',
            type: 'cascader',
            props: { multiple: true },
            collapseTags: true,
            onChange: () => {
              this.handleCityChange();
            },
          },
          {
            label: '配送区县',
            value: 'distributionArea',
            placeholder: '请选择配送区县',
            type: 'cascader',
            props: { multiple: true },
            collapseTags: true,
            onChange: () => {
              this.handleChangeIdToText();
            },
          },
          {
            label: '线路名称',
            value: 'lineCodeName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
        ],
        rules: {
          sourceAddressInfo: [
            { required: true, message: '请输入出发地址', trigger: 'submit' },
          ],
          sourceAddressNavigation: [
            { required: true, message: '请输入导航地址', trigger: 'submit' },
          ],
          targetCity: [
            { required: true, message: '请选择目的城市', trigger: 'submit' },
          ],
          distributionArea: [
            { required: true, message: '请选择配送区县', trigger: 'submit' },
          ],
          lineCodeName: [
            { required: true, message: '请选择线路名称', trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },

    handleStartingAddressChange () {
      const sourceAddressInfo = this.$refs.baseForm.getVal('sourceAddressInfo');
      if (sourceAddressInfo && Object.keys(sourceAddressInfo).length) {
        this.$refs.baseForm.setVal('sourceAddressNavigation', sourceAddressInfo.addressNavigation);
      }
    },

    chooseCustomerChange (data) {
      if (data && data.customerName) {
        this.customerName = data.customerName;
      }
    },

    setAddressInfo (data) {
      this.addressList = data;
    },

    async getOptions () {
      if (!this.baseForm.targetCityOptions.length) {
        const targetCityOptions = JSON.parse(JSON.stringify(this.addressList));
        targetCityOptions.forEach((province) => {
          province.children.forEach((city) => {
            delete city.children;
          });
        });
        this.baseForm.targetCityOptions = targetCityOptions;
      }
    },

    getDistrictInfo (data) {
      let targetCityOptions = [];
      for (let item of data) {
        this.addressList.forEach((province) => {
          if (province.value === item[0]) {
            for (let itemCity of province.children) {
              if (itemCity.value === item[1]) {
                const children = itemCity.children;
                const options = {
                  label: itemCity.label,
                  value: itemCity.value,
                  children,
                };
                if (!(targetCityOptions.find((info) => info.value === item[1]))) {
                  targetCityOptions.push(options);
                }
              }
            }
          }
        });
      }
      return targetCityOptions;
    },

    // 选择的省份和城市，根据省和市的id，筛选出可以选择的区/县
    async handleCityChange () {
      const targetCity = await this.$refs.baseForm.getVal('targetCity');
      // 已选中的
      if (targetCity) {
        // 复制一份，避免被干扰
        const targetCityOptions = JSON.parse(JSON.stringify(this.baseForm.targetCityOptions));
        // 标记已选中的
        for (let itemChildren of targetCityOptions) {
          for (let item of itemChildren.children) {
            item.active = false;
            for (let itemData of targetCity) {
              // 如果是当前选中的，在 targetCityOptions 里面标记一下
              if (itemData[1] === item.value) {
                item.active = true;
              }
            }
          }
        }

        // 删除已选中的，然后剩下的就是未选中的
        for (let item of targetCityOptions) {
          for (let i = item.children.length - 1; i >= 0; i--) {
            if (item.children[i].active) {
              item.children.splice(i, 1);
            }
          }
        }

        // 获取已选择的城市所属县/区
        this.baseForm.distributionAreaOptions = this.getDistrictInfo(targetCity);
      }
    },

    // 把城市和县区的id替换成中文，提供给线路名称使用
    handleChangeIdToText (isInit = false) {
      // 获取已选中的区县
      const data = this.$refs.baseForm.getVal('distributionArea');
      let unSelectDistrictOptions = [];
      if (data && data.length) {
        const desTempList = JSON.parse(JSON.stringify(data));
        const distributionAreaOptions = JSON.parse(JSON.stringify(this.baseForm.distributionAreaOptions));
        for (let item of desTempList) {
          for (let itemOpiton of distributionAreaOptions) {
            if (item[0] === itemOpiton.value) {
              for (let itemChildren of itemOpiton.children) {
                if (item[1] === itemChildren.value) {
                  itemChildren.active = true;
                  item[0] = itemOpiton.label;
                  item[1] = itemChildren.label;
                }
              }
            }
          }
        }
        if (desTempList.length) {
          this.desTempList = desTempList;
        }
        for (let item of distributionAreaOptions) {
          for (let i = item.children.length - 1; i >= 0; i--) {
            if (item.children[i].active) {
              item.children.splice(i, 1);
            }
          }
        }
        unSelectDistrictOptions = distributionAreaOptions;
      } else {
        this.desTempList = [];
      }
      if (!isInit) {
        this.setLineCodeName();
      }
      this.$emit('getUnSelectDistrict', unSelectDistrictOptions);
    },

    onChangeAddressMap (data) {
      if (data) {
        this.sourceTemp = data.addressDetail;
        this.setLineCodeName();
      }
    },

    setLineCodeName () {
      // 过滤掉始发和终点的一些字眼
      const sourceAddress = `${this.sourceTemp.city ? this.sourceTemp.city.replace(/自治州$|地区$|市$/g, '') : ''}${this.sourceTemp.district ? this.sourceTemp.district.replace(/市$|县$|区$/g, '') : ''}`;
      let desAddressList = [];
      if (this.desTempList.length) {
        for (let item of this.desTempList) {
          desAddressList.push(item[0] + item[1]);
        }
      } else {
        desAddressList = [];
      }
      const desAddress = desAddressList.length ? desAddressList.join(' - ') : '';
      const lineCodeName = `${sourceAddress ? sourceAddress + ' - ' : ''}${desAddress}`;
      this.$refs.baseForm.setVal('lineCodeName', lineCodeName);
    },

    // 整理提交的数据格式，一个县区就是一条数据
    subLineAreaDataFormat () {
      let subLineAreaBaseList = [];

      const data = this.$refs.baseForm.getVal('distributionArea');
      if (data && data.length) {
        for (let item of data) {
          for (let itemProvince of this.addressList) {
            if (itemProvince.children && itemProvince.children.length) {
              for (let itemCity of itemProvince.children) {
                if (itemCity.value === item[0]) {
                  for (let itemDistrict of itemCity.children) {
                    if (itemDistrict.value === item[1]) {
                      subLineAreaBaseList.push({
                        lineType: 0,
                        desProvince: itemProvince.value,
                        desProvinceName: itemProvince.label,
                        desCity: itemCity.value,
                        desCityName: itemCity.label,
                        desCounty: itemDistrict.value,
                        desCountyName: itemDistrict.label,
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }

      // 这里主要是为了让各个项塞进去 id
      const subLinaAreaBackUp = typeof this.subLinaAreaBackUp === 'string' ? JSON.parse(this.subLinaAreaBackUp) : [];
      if (subLinaAreaBackUp && Array.isArray(subLinaAreaBackUp)) {
        if (subLinaAreaBackUp.length) {
          for (let item of subLinaAreaBackUp) {
            if (item.lineType === 0) {
              for (let itemCur of subLineAreaBaseList) {
                if (
                  item.desProvince === itemCur.desProvince &&
                  item.desCity === itemCur.desCity &&
                  item.desCounty === itemCur.desCounty
                ) {
                  itemCur.cclaId = item.cclaId;
                  itemCur.lineId = item.lineId;
                  itemCur.customerId = item.customerId;
                }
              }
            }
          }
        }
      }

      return subLineAreaBaseList;
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.targetCity;
        delete formData.distributionArea;
        delete formData.sourceAddressInfo;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        const sourceAddressInfo = formData.sourceAddressInfo;
        let sourceAddressDetail = {};
        if (sourceAddressInfo) {
          sourceAddressDetail = {
            sourceAddress: sourceAddressInfo.addressDtl,

            sourceProvince: sourceAddressInfo.provinceId,
            // sourceProvinceName: xxx.addressDetail.province,
            sourceCity: sourceAddressInfo.cityId,
            // sourceCityName: xxx.addressDetail.city,
            sourceCounty: sourceAddressInfo.districtId,
            // sourceCountyName: xxx.addressDetail.district,
            // 始发地导航地址
            // sourceAddressNavigation: sourceAddressInfo.addressNavigation,
            // 始发地经度
            sourceEand: sourceAddressInfo.addressNavigationLng,
            // 始发地纬度
            sourceNand: sourceAddressInfo.addressNavigationLat,
          };
        }

        let subLineAreaBaseList = this.subLineAreaDataFormat();

        if (subLineAreaBaseList.length) {
          subLineAreaBaseList = JSON.stringify(subLineAreaBaseList);
        } else {
          subLineAreaBaseList = '[]';
        }

        formData = {
          ...formData,
          // ...navAddressDetail,
          ...sourceAddressDetail,
          subLineAreaBaseList,
          subLinaAreaBackUp: this.subLinaAreaBackUp,
        };
      }
      return formData;
    },
    async init (data = {}) {

      await this.getOptions();

      this.sourceTemp = {
        city: data.sourceCityName || '',
        district: data.sourceCountyName || '',
      };

      data.sourceAddressInfo = {
        addressDtl: data.sourceAddress || '',
        addressNavigation: data.sourceAddressNavigation || '',
        addressNavigationLat: data.sourceEand || '',
        addressNavigationLng: data.sourceEand || '',
        provinceId: data.sourceProvince || '',
        cityId: data.sourceCity || '',
        districtId: data.sourceCounty || '',
      };

      if (data.subLinaArea && data.subLinaArea.length) {
        const targetCity = [];
        const distributionArea = [];
        for (let item of data.subLinaArea) {
          if (item.lineType === 0) {
            targetCity.push([item.desProvince, item.desCity]);
            distributionArea.push([item.desCity, item.desCounty]);
          }
        }
        data.targetCity = targetCity;
        data.distributionArea = distributionArea;
        this.subLinaAreaBackUp = JSON.stringify(data.subLinaArea);
      }

      this.otherFormData.subLinaAreaList = JSON.parse(data.subLineAreaBaseList || '[]');

      this.$refs.baseForm.setVal(data);
      await this.handleCityChange();
      this.handleChangeIdToText(true);
      this.handleStartingAddressChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
